export default "__VITE_ASSET__BENxRT_M__"